// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import PostList from '../components/PostList.vue';
import PostDetail from '../components/PostDetail.vue';
import AddPostForm from '../components/AddPostForm.vue';

const routes = [
  { path: '/', name: 'Home', component: PostList },
  { path: '/post/:id', name: 'PostDetail', component: PostDetail, props: true },
  { path: '/add', name: 'AddPost', component: AddPostForm }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;